import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';

interface SelectListProps {
    onChange;
    options: any[];
    value?;
}

@observer export class SelectList extends Component<SelectListProps, any> {

    render() {
        const { options, value, onChange } = this.props;

        return <select className={'form-control'} value={value} onChange={item => {
            onChange(item.target.value);
        }}>
            { options.map(item => (
                <option key={item.value} value={item.value}>{ item.label }</option>
            )) }
        </select>
    }

}
